@if (isLoading) {
  <app-loading-animation />
}
@if (!isLoading && error === null) {
  <div class="order-headline">
    <div class="order-text">
      <div class="text">
        <div class="title-text">
          <div style="display: flex; align-items: center">
          <h2>Auftrag {{ orderDetail.orderNumber }}</h2>
          <i
            class="pi pi-clone copy-icon-button"
            (click)="copyOrderNumber()"
            (keyup.enter)="copyOrderNumber()"
            (keyup.space)="copyOrderNumber()"
            tabindex="0"
            aria-label="Auftragsnummer kopieren"
            title="Auftragsnummer kopieren"
          ></i>
          </div>
          @if (orderDetail.zohoId) {
            <a
              [href]="
            'https://crm.zoho.eu/crm/org20093979379/tab/SalesOrders/' + orderDetail.zohoId
          "
              target="_blank"
              (keyup.enter)="navigateToZoho(orderDetail.zohoId)"
              (keyup.space)="navigateToZoho(orderDetail.zohoId)"
              tabindex="0"
            >Zoho</a
            >
          }
        </div>
        <div
          class="aggregate-analysis-dropdown-button"
          (click)="openAggregateAnalysis()"
        >
          <img [src]="getArrowImage()" alt="" />
        </div>
      </div>
      @if (!isShowingAggregateAnalysis) {
        <div class="status">
          <div class="status-symbols">
            <app-chip [status]="orderDetail.status" [hasText]="true" />
            <span
            >Auftr.status</span
            >
          </div>
          @if (orderDetail.hygiene?.status) {
            <div class="status-symbols">
              <app-chip
                [status]="orderDetail.hygiene?.status"
                [hasText]="true"
              />
              <span>Hyg.status</span>
            </div>
          }
          @if (orderDetail.energetic?.status) {
            <div class="status-symbols">
              <app-chip
                [status]="orderDetail.energetic?.status"
                [hasText]="true"
              />
              <span>Energ.status</span>
            </div>
          }
        </div>
      }
    </div>
    <div>
      <div class="issues">
        @if (hasUserRole(UserRole.BACKOFFICE_REVIEWER_HYGIENE)) {
          <button (click)="downloadValidationIssuesCSV(orderDetail.orderNumber)"
                  [disabled]="isDownloadingValidationIssues || isValidationIssuesDisabled"
                  [ngStyle]="validationIssuesStyle" type="button" class="secondary-icon-button">
            <ng-container *ngIf="!isDownloadingValidationIssues; else issuesSpin">
              <img src="/assets/icons/issues.svg" alt="Validation Issues" />
            </ng-container>
            <ng-template #issuesSpin>
              <p-progressSpinner
                styleClass="btn-spinner"
                strokeWidth="8"
                [style]="{ width:'18px', height:'18px' }"
              ></p-progressSpinner>
            </ng-template>
            <span>Validation-Issues</span>
          </button>
        }
      </div>
      <div class="action-buttons">
        @if (hasUserRole(UserRole.BACKOFFICE_REVIEWER_HYGIENE) ||
        orderDetail.status === OrderStatus.ReadyForShipment ||
        orderDetail.status === OrderStatus.ShippedToCustomer) {
          <div
            (click)="!isDownloadingDocumentation && downloadOrderReport(orderDetail.id)"
            class="report-button cell-styling"
            [ngClass]="{ 'download-disabled': isDownloadingDocumentation }"
          >
            <ng-container *ngIf="!isDownloadingDocumentation; else docSpin">
              <img src="/assets/download-alt.svg" alt="Download Icon" class="report-button-icon" />
            </ng-container>
            <ng-template #docSpin>
              <p-progressSpinner class="btn-spinner report-button-icon" strokeWidth="8"
                                 [style]="{ width:'18px', height:'18px' }"></p-progressSpinner>
            </ng-template>
            Dokumentation
          </div>
        }
        @if (hasUserRole(UserRole.BACKOFFICE_SHIPPER) ||
        hasUserRole(UserRole.BACKOFFICE_USER) ||
        orderDetail.status === OrderStatus.ReadyForShipment ||
        orderDetail.status === OrderStatus.ShippedToCustomer) {
          <div
            (click)="!isDownloadingPerformance && downloadPerformanceReports(orderDetail.orderNumber)"
            class="report-button cell-styling"
            [ngClass]="{ 'download-disabled': isDownloadingPerformance }"
          >
            <ng-container *ngIf="!isDownloadingPerformance; else perfSpin">
              <img src="/assets/download-alt.svg" alt="Download Icon" class="report-button-icon" />
            </ng-container>
            <ng-template #perfSpin>
              <p-progressSpinner class="btn-spinner report-button-icon" strokeWidth="8"
                                 [style]="{ width:'18px', height:'18px' }"></p-progressSpinner>
            </ng-template>
            Leistungsnachweis
          </div>
        }
        @if (hasUserRole(UserRole.BACKOFFICE_ADMIN)) {
          <app-button
            (click)="generateArtifacts(orderDetail.id)"
            type="primary-icon-button"
            icon="/assets/icons/generate_artifacts.svg"
            label="Generiere Dokumentation"
          />
        }
        @if (hasUserRole(UserRole.BACKOFFICE_CUSTOMER_ACCESS_MANAGER)) {
          <app-button
            (click)="openAssignGroupDialog()"
            [disabled]="!canOpenGroupAssignment"
            type="secondary-icon-button"
            icon="/assets/add.svg"
            label="Gruppe zuweisen"
          />
        }
        @if (orderDetail.hygiene?.status === HygieneInspectionStatus.InReview &&
        hasUserRole(UserRole.BACKOFFICE_REVIEWER_HYGIENE)) {
          <app-button
            (click)="setInspectionStatus(HygieneInspectionStatus.Completed)"
            type="primary-icon-button"
            icon="/assets/icons/check.svg"
            label="Hygieneinspektion abschließen"
          />
        }

        @if (orderDetail.status === OrderStatus.ReadyForShipment &&
        hasUserRole(UserRole.BACKOFFICE_SHIPPER)) {
          <app-button
            (click)="setOrderStatus(OrderStatus.ShippedToCustomer)"
            type="primary-icon-button"
            icon="/assets/icons/versendet.svg"
            label="Versand bestätigen"
          />
        }
        @if (orderDetail.status === OrderStatus.Created &&
        (hasUserRole(UserRole.BACKOFFICE_ADMIN) || hasUserRole(UserRole.BACKOFFICE_PLANNER))) {
          <div (click)="toggleDeleteDialog()" class="delete-button cell-styling">
            <img src="/assets/trash.svg" alt="Delete Icon" />
          </div>
        }
      </div>
    </div>
  </div>
  @if (isShowingAggregateAnalysis) {
    <p-tabView>
      <p-tabPanel header="Anlagen Statistik">
        <app-aggregate-analysis [orderDetail]="orderDetail" />
      </p-tabPanel>
      <p-tabPanel header="Auftrags Kommentare">
        @if (orderDetail.noteInternalBackoffice) {
          <app-comment-detail-card
            title="Backoffice"
            (click)="openCommentDialog(orderDetail.id, orderDetail.noteInternalBackoffice, commentType.ORDER_BACKOFFICE_COMMENT)"
            tabindex="0"
          ><p>{{ orderDetail.noteInternalBackoffice }}
          </p>
          </app-comment-detail-card>
        }
        @if (orderDetail.noteInternalInspector) {
          <app-comment-detail-card
            title="Techniker"
            tabindex="0"
          ><p>{{ orderDetail.noteInternalInspector }}
          </p>
          </app-comment-detail-card>
        }
        @if (!orderDetail.noteInternalBackoffice) {
          <app-button
            (click)="openCommentDialog(orderDetail.id,orderDetail.noteInternalBackoffice,commentType.ORDER_BACKOFFICE_COMMENT)"
            type="secondary-icon-button"
            icon="/assets/add.svg"
            label="Neuer Backoffice Kommentar"
          />
        }
      </p-tabPanel>
      @if (hasValidTasks(orderDetail)) {
        <p-tabPanel header="Beauftragungen">
          <p-accordion>
            <p-accordionTab [header]="getTaskLabel(task.type) + ' (' + task.done + ' / ' + task.ordered + ')'"
                            *ngFor="let task of orderDetail.hygiene?.remuneratedTasks"
                            [disabled]="!task.notAchievableReason">
              <p>
                <app-notification-card>
                  <p>{{ task.notAchievableReason }}</p>
                </app-notification-card>
              </p>
            </p-accordionTab>
          </p-accordion>
        </p-tabPanel>
      }
    </p-tabView>
  }

  <app-dialog
    [orderDetail]="orderDetail"
    (orderChangedEvent)="updateDetailOnChange()"
  />

  <app-comment-dialog
    (orderChangedEvent)="updateDetailOnChange()"
  />

  <p-dialog
    header="Gruppe zuweisen"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [closable]="!isSavingAssignableGroups"
    [visible]="showAssignGroupDialog"
    [style]="{ width: 'min(38rem, 92vw)' }"
    (visibleChange)="showAssignGroupDialog = $event"
    (onHide)="closeAssignGroupDialog()"
  >
    <div class="group-assignment-dialog">
      <p class="group-assignment-intro">
        Wähle die Gruppen aus, denen der Auftrag <strong>{{ orderDetail.orderNumber }}</strong> zugewiesen werden soll.
      </p>

      @if (isLoadingAssignableGroups) {
        <div class="group-assignment-loading">
          <p-progressSpinner
            strokeWidth="8"
            [style]="{ width:'28px', height:'28px' }"
          ></p-progressSpinner>
        </div>
      } @else if (assignableGroups.length === 0) {
        <p class="group-assignment-empty">
          Für diesen Kunden sind aktuell keine Gruppen vorhanden.
        </p>
      } @else {
        <div class="group-assignment-list">
          @for (group of assignableGroups; track group.id) {
            <label class="group-assignment-row">
              <input
                type="checkbox"
                [checked]="!!group.selected"
                [disabled]="isSavingAssignableGroups"
                (change)="toggleGroupSelection(group.id, $any($event.target).checked)"
              />
              <span class="group-assignment-copy">
                <strong>{{ group.name }}</strong>
                <span>{{ group.orderTitles?.join(', ') || 'Noch keine Aufträge zugewiesen' }}</span>
              </span>
            </label>
          }
        </div>
      }

      <div class="group-assignment-actions">
        <app-button
          (click)="closeAssignGroupDialog()"
          [disabled]="isSavingAssignableGroups"
          type="tertiary-button"
          label="Abbrechen"
        />
        <app-button
          (click)="saveGroupAssignments()"
          [disabled]="!canSaveGroupAssignments || isSavingAssignableGroups"
          type="primary-button"
          label="Speichern"
        />
      </div>
    </div>
  </p-dialog>

  <div class="card-container">
    <app-detail-card
      title="Kunde"
      backgroundImage="/assets/customer.svg"
      hoverBackgroundImage="/assets/customer-hover.svg"
      [zohoId]="orderDetail.customer.zohoId"
    >
      <p>
        <strong>{{ orderDetail.customer.name }}</strong> <br />
        {{ orderDetail.customer.street }} <br /> {{ orderDetail.customer.zipCode }} {{ orderDetail.customer.city }}
        <br />
        {{ orderDetail.customer.country }}
      </p></app-detail-card
    >
    <app-detail-card
      title="Standort"
      backgroundImage="/assets/location.svg"
      hoverBackgroundImage="/assets/location-hover.svg"
      [zohoId]="orderDetail.location.zohoId"
    ><p>
      <strong>{{ orderDetail.location.name }}</strong> <br />
      {{ orderDetail.location.street }} <br />  {{ orderDetail.location.zipCode }} {{ orderDetail.location.city }}
      <br />
      {{ orderDetail.location.country }}
    </p>
    </app-detail-card>
    <app-detail-card
      title="Start- und Enddatum"
      backgroundImage="/assets/date.svg"
      hoverBackgroundImage="/assets/date-hover.svg"
      (click)="openDialog()"
      (keyup.enter)="openDialog()"
      (keyup.space)="openDialog()"
      tabindex="0"
    >
      <p>
        {{ orderDetail.startDate ? formatDate(orderDetail.startDate) : 'Kein Startdatum' }}
        {{ orderDetail.endDate ? '/ ' + formatDate(orderDetail.endDate) : ' / Kein Enddatum' }}
        <br />
      </p>
    </app-detail-card>

    <app-detail-card
      title="Prüfende Person"
      backgroundImage="/assets/inspector.svg"
      hoverBackgroundImage="/assets/inspector-hover.svg"
      (click)="openDialog()"
      (keyup.enter)="openDialog()"
      (keyup.space)="openDialog()"
      tabindex="0"
    ><p>
      @for (inspector of orderDetail.inspectors;
        track inspector.id;
        let index = $index) {
        <span
        >{{ inspector.firstName }} {{ inspector.lastName }}
          @if (index !== orderDetail.inspectors.length - 1) {
            , <br />
          }
          </span>
      }
    </p>
    </app-detail-card>
  </div>
  <app-aggregate-filter (filtered)="applyClientSideFilter($event)"></app-aggregate-filter>

  <app-detail-table
    [orderDetail]="orderDetail"
    [aggregates]="filteredAggregates"
    (requestParentReload)="ngOnInit()"
  />


  @if (showDeleteDialog) {
    <div class="delete-dialog-container">
      <div class="delete-dialog">
        <div class="icon-container">
          <img src="/assets/trash-red.svg" alt="Delete Icon" />
        </div>

        <h3>Auftrag löschen</h3>
        <p>
          Bist du sicher, dass du den Auftrag
          <b>{{ orderDetail.orderNumber }}</b>
          löschen willst?
        </p>
        <div class="dialog-buttons">
          <app-button
            type="tertiary-button"
            label="Abbrechen"
            (click)="toggleDeleteDialog()"
          />
          <app-button
            type="primary-button-red"
            label="Löschen"
            (click)="deleteOrder(orderDetail.id)"
            [disabled]="isDeleteButtonDisabled"
          />
        </div>
      </div>
    </div>
  }
}
@if (error) {
  <div class="order-headline">
    <h2>Auftrag Unbekannt</h2>
  </div>
  <div class="error-container">
    <app-error [error]="error" />
  </div>
}
